import React, { useState, useRef, useEffect } from 'react';
import { api, getListItems } from '../../services/api';

function FaqInner() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const contentRefs = useRef([]);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await api.getFaqs();
        const items = getListItems(res).map((item) => ({
          question: item.question || item.title || '',
          answer: item.answer || item.content || '',
        })).filter((item) => item.question);
        if (!cancelled) setFaqs(items);
      } catch (err) {
        if (!cancelled) setError(err.message || 'Unable to load FAQs');
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  useEffect(() => {
    contentRefs.current.forEach((ref, index) => {
      if (ref) {
        ref.style.maxHeight = activeIndex === index ? `${ref.scrollHeight}px` : '0px';
      }
    });
  }, [activeIndex, faqs]);

  if (!loading && faqs.length === 0) {
    return null;
  }

  return (
    <div className="space-top space-extra-bottom">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-7">
            <div className="title-area text-center">
              <span className="sub-title">FAQ</span>
              <h2 className="sec-title">Frequently Asked Questions</h2>
              <p>Have questions you want answers to?</p>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-10 offset-lg-1">
            {loading && <p className="text-center">Loading FAQs…</p>}
            {error && <p className="text-center text-danger">{error}</p>}
            {!loading && !error && faqs.length > 0 && (
            <div className="accordion-area mb-30">
              {faqs.map((faq, index) => (
                <div
                  key={index}
                  className={`accordion-card style2 ${activeIndex === index ? 'active' : ''}`}
                >
                  <div className="accordion-header">
                    <button
                      type="button"
                      className={`accordion-button ${activeIndex === index ? '' : 'collapsed'}`}
                      onClick={() => toggleAccordion(index)}
                    >
                      Q{index + 1}. {faq.question}
                    </button>
                  </div>
                  <div
                    ref={(el) => { contentRefs.current[index] = el; }}
                    className="accordion-collapse"
                  >
                    <div className="accordion-body">
                      <p className="faq-text">{faq.answer}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default FaqInner;
